import {
  CurationStatusesFilter,
  Month,
  ProductNotificationFilter,
  ProductTargetGroup,
  ProductType,
} from "../types";
import {
  getCurationStatusKey,
  getMonthKey,
  getProductTypeHeaderKey,
  getTargetGroupKey,
} from "./localizationUtils";

export const targetGroupsOptions = [ProductTargetGroup.BTOC, ProductTargetGroup.BTOB].map(
  (group) => ({
    labelKey: getTargetGroupKey(group),
    value: group,
  })
);

export const monthOptions = Object.values(Month).map((month) => ({
  label: getMonthKey(month),
  value: month,
}));

export const productTypeOptions = [
  {
    labelKey: getProductTypeHeaderKey(ProductType.Accommodation),
    value: ProductType.Accommodation,
  },
  {
    labelKey: getProductTypeHeaderKey(ProductType.Attraction),
    value: ProductType.Attraction,
  },
  {
    labelKey: getProductTypeHeaderKey(ProductType.Experience),
    value: ProductType.Experience,
  },
  {
    labelKey: getProductTypeHeaderKey(ProductType.Event),
    value: ProductType.Event,
  },
  {
    labelKey: getProductTypeHeaderKey(ProductType.RentalService),
    value: ProductType.RentalService,
  },
  {
    labelKey: getProductTypeHeaderKey(ProductType.Restaurant),
    value: ProductType.Restaurant,
  },
  {
    labelKey: getProductTypeHeaderKey(ProductType.Shop),
    value: ProductType.Shop,
  },
  {
    labelKey: getProductTypeHeaderKey(ProductType.Venue),
    value: ProductType.Venue,
  },
  {
    labelKey: getProductTypeHeaderKey(ProductType.Transportation),
    value: ProductType.Transportation,
  },
];

export const curationStatuses = [
  CurationStatusesFilter.New,
  CurationStatusesFilter.Pending,
  CurationStatusesFilter.Updated,
  CurationStatusesFilter.Approved,
  CurationStatusesFilter.ApprovedAndUpdated,
  CurationStatusesFilter.All,
].map((status) => ({
  label: getCurationStatusKey(status),
  value: status,
}));

export const companyProductStatuses = [
  CurationStatusesFilter.Draft,
  CurationStatusesFilter.CurationPending,
  CurationStatusesFilter.Approved,
  CurationStatusesFilter.AllCompanyProducts,
].map((status) => ({
  label: getCurationStatusKey(status),
  value: status,
}));

export const productNotificationOptions = [
  // { value: ProductNotificationFilter.BrokenLink, label: "curatorWorkspace.brokenLinkFilter" },
  { label: "curatorWorkspace.commentFilter", value: ProductNotificationFilter.NewComment },
];

export const externalSourceOptions = [
  { label: "Bòkun", value: "bokun" },
  { label: "Johku", value: "johku" },
];
